import { Quote, Star, Stethoscope, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

const TESTIMONIALS = [
    {
        key: "t1",
        name: "Bataria Mayror Chol",
        country: "Sudan",
        doctor: "Dr. Sandeep Vaishya",
        speciality: "Neurosurgery",
    },
    {
        key: "t2",
        name: "Dilafruz Akhmadonova",
        country: "Uzbekistan",
        doctor: "Dr. Sameer Mehrotra",
        speciality: "Interventional Cardiologist",
    },
    {
        key: "t3",
        name: "Ammar Salim Mustafa",
        country: "Iraq",
        doctor: "Dr. Nikhil Kumar",
        speciality: "Cardiologist",
    },
];

export const Testimonials = () => {
    const { t } = useTranslation();
    return (
        <section
            id="testimonials"
            data-testid="testimonials-section"
            className="relative py-20 md:py-28"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="max-w-3xl mb-14">
                    <div className="text-xs uppercase tracking-[0.2em] text-orange-600 font-semibold mb-3">
                        {t("testimonials.eyebrow")}
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-stone-900 leading-[1.05]">
                        {t("testimonials.title")}
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {TESTIMONIALS.map((tm, i) => (
                        <figure
                            key={tm.name}
                            data-testid={`testimonial-${i}`}
                            className={`relative rounded-3xl p-7 md:p-8 border overflow-hidden transition-all hover:-translate-y-1 flex flex-col ${
                                i === 1
                                    ? "bg-brand-700 text-white border-brand-700"
                                    : "bg-white border-stone-200"
                            }`}
                        >
                            <Quote
                                className={`absolute -top-2 -right-2 h-32 w-32 ${
                                    i === 1 ? "text-white/10" : "text-brand-50"
                                }`}
                                strokeWidth={1}
                            />

                            <div className="relative flex gap-0.5">
                                {[...Array(5)].map((_, idx) => (
                                    <Star
                                        key={idx}
                                        className={`h-4 w-4 ${
                                            i === 1
                                                ? "fill-amber-300 text-amber-300"
                                                : "fill-amber-500 text-amber-500"
                                        }`}
                                    />
                                ))}
                            </div>

                            <blockquote
                                data-testid={`testimonial-quote-${i}`}
                                className={`relative mt-5 text-[15px] leading-relaxed flex-1 ${
                                    i === 1 ? "text-brand-50" : "text-stone-700"
                                }`}
                            >
                                “{t(`testimonials.${tm.key}`)}”
                            </blockquote>

                            <figcaption
                                className={`relative mt-6 pt-5 border-t ${
                                    i === 1 ? "border-white/20" : "border-stone-200"
                                }`}
                            >
                                <div
                                    data-testid={`testimonial-name-${i}`}
                                    className={`font-display text-lg font-bold ${
                                        i === 1 ? "text-white" : "text-stone-900"
                                    }`}
                                >
                                    {tm.name}
                                </div>
                                <div
                                    className={`mt-2 flex items-center gap-2 text-xs ${
                                        i === 1 ? "text-brand-100" : "text-stone-600"
                                    }`}
                                >
                                    <MapPin className="h-3.5 w-3.5" />
                                    <span data-testid={`testimonial-country-${i}`}>
                                        {tm.country}
                                    </span>
                                </div>
                                <div
                                    className={`mt-1.5 flex items-start gap-2 text-xs ${
                                        i === 1 ? "text-brand-100" : "text-stone-600"
                                    }`}
                                >
                                    <Stethoscope className="h-3.5 w-3.5 mt-0.5 flex-shrink-0" />
                                    <span data-testid={`testimonial-doctor-${i}`}>
                                        {tm.doctor} · {tm.speciality}
                                    </span>
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};
